const adminPages = [
  { id: 'products', label: 'Каталог', icon: '📦', iconSrc: '/icons/catalog.svg' },
  { id: 'orders', label: 'Заказы', icon: '📋', iconSrc: '/icons/orders.svg' },
  { id: 'calendar', label: 'Календарь', icon: '📅', iconSrc: '/icons/calendar.svg' },
  { id: 'courier-assignment', label: 'Курьеры', icon: '🚗', iconSrc: '/icons/delivery.svg' },
  { id: 'warehouse', label: 'Склад', icon: '📥', iconSrc: '/icons/warehouse.svg' },
  { id: 'employees', label: 'Сотрудники', icon: '👷', iconSrc: '/icons/employees.svg' },
  { id: 'users', label: 'Клиенты', icon: '👥', iconSrc: '/icons/clients.svg' },
  { id: 'broadcast', label: 'Рассылка', icon: '📢', iconSrc: '/icons/bell.svg' },
  { id: 'certificates', label: 'Сертификаты', icon: '🎁', iconSrc: '/icons/mail.svg' },
  { id: 'flowwow', label: 'Flowwow', icon: '🌸', iconSrc: '/icons/flowwow.svg' },
  { id: 'analytics', label: 'Аналитика', icon: '📊', iconSrc: '/icons/analytics.svg' },
  { id: 'settings', label: 'Настройки', icon: '⚙️', iconSrc: '/icons/settings.svg' },
];

export const rolePages = {
  // Владелец видит всё админское; внутри разделов ему доступны
  // эксклюзивы (Статистика, CRUD сотрудников, переименование разделов).
  owner: adminPages,
  // Рассылки — только владельцу (решение 2026-08-10)
  admin: adminPages.filter(p => p.id !== 'broadcast'),
  florist: [
    { id: 'florist-orders', label: 'Мои заказы', icon: '💐', iconSrc: '/icons/orders.svg' },
  ],
  packer: [
    { id: 'packer-orders', label: 'Упаковка', icon: '📦', iconSrc: '/icons/catalog.svg' },
  ],
  courier: [
    { id: 'courier-deliveries', label: 'Доставки', icon: '🚚', iconSrc: '/icons/delivery.svg' },
  ],
};

export const roleLabels = {
  owner: 'Владелец',
  admin: 'Администратор',
  florist: 'Флорист',
  packer: 'Упаковщик',
  courier: 'Курьер',
};

export function getDefaultPage(role) {
  const pages = rolePages[role];
  return pages ? pages[0].id : 'products';
}
